module.exports = __webpack_public_path__ + "static/media/boy.d8dcf0ef.svg";